import React, { useState, useEffect } from "react";
import {
	CircularProgressbarWithChildren,
	buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import NumberPad from "../components/NumberPad";
import { SmallCircleButton } from "../../../components/common/SmallCircleButton";

const DiallingScreen = ({
	disconnectCall,
	phoneNumber,
	onCall,
	toggleMute,
	muted,
	isSatellite,
	sendNumber: sendNumberProp,
	onClose,
}) => {
	const [digits, setDigits] = useState("");
	const [timeToConnect, setTimeToConnect] = useState(0);
	const [timerId, setTimerId] = useState(null);
	const [isConnecting, setIsConnecting] = useState(false);
	const [showNumPad, setShowNumPad] = useState(false);

	useEffect(() => {
		if (isConnecting === true) {
			const intervalId = setInterval(() => {
				console.log("Time To Connect", timeToConnect);
				setTimeToConnect((prevTime) => {
					if (prevTime === 45) {
						setIsConnecting(false);
						clearInterval(intervalId);
						return prevTime;
					}
					return prevTime + 1;
				});
			}, 1000);

			setTimerId(intervalId);
		}

		// Cleanup function
		return () => {
			if (timerId) {
				clearInterval(timerId);
			}
		};
	}, [isConnecting]);

	const showNumPadHandler = () => {
		setShowNumPad(true);
	};

	const hideNumPadHandler = () => {
		setShowNumPad(false);
	};

	const sendNumber = (digit) => {
		setDigits((prevDigits) => prevDigits + "" + digit);
		sendNumberProp(digit);
	};

	const percentage = Math.round((timeToConnect / 45) * 100);

	return (
		<div className="p-3 bg-gradient-to-b from-gray-600 to-gray-800 min-h-[575px] h-auto rounded-md overflow-hidden">
			<div className="flex justify-between">
				<div />
				{!onCall && (
					<SmallCircleButton
						backgroundColor="#2A2D3C"
						color="#fff"
						iconClass="icon-cross"
						onClick={onClose}
					/>
				)}
			</div>

			<div className="mt-2 text-center">
				<div className="text-3xl font-bold text-white">
					{phoneNumber}
				</div>
				{!onCall && (
					<div className="text-green-400 text-lg font-bold">
						Calling...
					</div>
				)}

				{onCall && (
					<div className="text-green-400 text-lg font-bold">
						{isSatellite && isConnecting ? "Connecting..." : "Connected"}
					</div>
				)}
			</div>

			<div className="flex justify-center items-center mt-5">
				{isSatellite ? (
					<CircularProgressbarWithChildren
						value={percentage}
						strokeWidth={1}
						styles={buildStyles({
							pathTransitionDuration: 0.4,
							pathColor: "#2FC76F",
							trailColor: "rgb(44, 49, 54)",
						})}
					>
						<img loading="lazy" src="/img/calling-emptyavatar.png" alt="Avatar" />
					</CircularProgressbarWithChildren>
				) : (
					<img loading="lazy" src="/img/calling-emptyavatar.png" alt="Avatar" />
				)}
			</div>

			{onCall && (
				<div className="mt-2 pt-2 flex justify-center">
					<SmallCircleButton
						backgroundColor="#2A2D3C"
						color="#fff"
						iconClass={muted ? "icon-mic-mute" : "icon-mic"}
						onClick={toggleMute}
						className="mx-2"
						border="0.92px solid #FFFFFF"
						size={60}
					/>
					<SmallCircleButton
						backgroundColor="#2A2D3C"
						color="#fff"
						iconFile={
							showNumPad ? null : "/img/tab-dialpad-icon@2x.png"
						}
						iconClass={showNumPad ? "icon-cross" : null}
						onClick={
							showNumPad ? hideNumPadHandler : showNumPadHandler
						}
						className="mx-2"
						border="0.92px solid #FFFFFF"
						size={60}
					/>
				</div>
			)}

			{showNumPad && (
				<div className="pad">
					{digits && (
						<div className="mt-2 px-4 flex justify-center text-2xl text-white">
							{digits}
						</div>
					)}
					<NumberPad onClick={sendNumber} color="#fff" />
				</div>
			)}

			<div className="flex justify-center items-center mt-4">
				<button
					className="flex justify-center items-center bg-red-500 hover:bg-red-600 rounded-full mb-2 mx-1 h-15 w-15"
					style={{ height: "60px", width: "60px" }}
					onClick={disconnectCall}
				>
					<img loading="lazy" src="/img/call-endcall-btn@2x.png" width="60" alt="End call" />
				</button>
			</div>
		</div>
	);
};

export default DiallingScreen;